import { checkThirdParty as checkControlledThirdParty } from '@atlassian/browser-storage-controls';

export const checkThirdParty = async (
	thirdParty: string,
	onAllowed: () => Promise<void>,
	onDenied?: () => Promise<void>,
): Promise<void> => {
	await checkControlledThirdParty(thirdParty, onAllowed, onDenied);
};
